contactUsCtrl.$inject = ['contactUsSetup'];

export default function contactUsCtrl(contactUsSetup) {
    const vm = this;
    vm.contactUsSetup = contactUsSetup;
}
